// extracted by mini-css-extract-plugin
export default {"boton":"CausaReaccionCrearScreen_boton__ocYmx"};